(function () {
  'use strict';

  var EXPRESS_SELECTORS = [
    '[data-shopify-buttoncontainer]',
    '.shopify-payment-button',
    '.dynamic-checkout-cart',
    '.additional-checkout-buttons',
    '.cart__dynamic-checkout-buttons'
  ].join(', ');

  function postCartUpdate(pc, tc) {
    return fetch('/cart/update.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        attributes: {
          'Zgoda RODO Polityka Prywatności': pc ? 'Tak' : 'Nie',
          'Zgoda RODO Regulamin':            tc ? 'Tak' : 'Nie'
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
    });
  }

  function trySave(pc, tc, retriesLeft) {
    return postCartUpdate(pc, tc).catch(function (err) {
      if (retriesLeft <= 0) throw err;
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          trySave(pc, tc, retriesLeft - 1).then(resolve, reject);
        }, 1000);
      });
    });
  }

  function initConsentContainers() {
    document.querySelectorAll('[data-cart-consent]').forEach(function (container) {
      if (container.dataset.consentInitialized) return;
      container.dataset.consentInitialized = 'true';

      var checkboxes = Array.from(container.querySelectorAll('input[type="checkbox"]'));
      var privacyCb  = container.querySelector('[id$="-consent-privacy"]');
      var termsCb    = container.querySelector('[id$="-consent-terms"]');

      var parent = container.closest('[data-cart-consent-scope]');
      var checkoutBtn = parent ? parent.querySelector('[data-consent-checkout]') : null;
      if (!checkoutBtn || !checkboxes.length) return;

      /* ----------------------------------------------------------------
       * confirmed — the single source of truth for whether checkout may
       * proceed. Set to true ONLY after a successful Tak/Tak server save
       * with no newer write pending. Cleared on every enqueue().
       * ---------------------------------------------------------------- */
      var confirmed    = false;
      var saving       = false;
      var pendingWrite = null;   // { pc, tc } — latest coalesced state

      function allChecked() {
        return checkboxes.every(function (cb) { return cb.checked; });
      }
      function getExpress() {
        return parent ? Array.from(parent.querySelectorAll(EXPRESS_SELECTORS)) : [];
      }

      /* Apply checkout-enabled state driven exclusively by `confirmed`. */
      function applyGating() {
        var allow = confirmed;
        checkoutBtn.disabled = !allow;
        checkoutBtn.classList.toggle('cart-consent--disabled', !allow);
        getExpress().forEach(function (el) {
          el.classList.toggle('cart-consent--express-disabled', !allow);
        });
      }
      function setError(visible) {
        container.classList.toggle('cart-consent--save-error', visible);
      }

      /**
       * Save the given state through the serialised queue.
       * All writes — including the initial Nie/Nie — go through here,
       * guaranteeing no concurrent requests reach the Shopify endpoint.
       */
      function startSave(pc, tc) {
        saving = true;

        trySave(pc, tc, 2).then(function () {
          saving = false;
          if (pendingWrite) {
            var next = pendingWrite;
            pendingWrite = null;
            startSave(next.pc, next.tc);
            return;
          }
          /* This is the settled, confirmed server state. */
          setError(false);
          if (pc && tc && allChecked()) {
            confirmed = true;   // Unlock only on confirmed Tak/Tak
            applyGating();
          }
        }).catch(function () {
          saving = false;
          if (pendingWrite) {
            var next = pendingWrite;
            pendingWrite = null;
            startSave(next.pc, next.tc);
            return;
          }
          /* All retries exhausted, no pending write: stay blocked. */
          confirmed = false;
          setError(true);
          applyGating();         // Re-applies disabled state; never fails open
        });
      }

      /**
       * Enqueue a save for the given state.
       * Immediately revokes `confirmed` so checkout stays blocked while
       * the write is in-flight or pending.
       */
      function enqueue(pc, tc) {
        confirmed = false;       // Revoke immediately — no optimistic enable
        applyGating();
        setError(false);

        if (saving) {
          pendingWrite = { pc: pc, tc: tc };  // Coalesce
        } else {
          startSave(pc, tc);
        }
      }

      /* ---- Initialise: route initial Nie/Nie through the queue ---- */
      enqueue(false, false);

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', function () {
          var pc = privacyCb ? privacyCb.checked : false;
          var tc = termsCb   ? termsCb.checked   : false;
          enqueue(pc, tc);
        });
      });

      /* Watch for express buttons Shopify injects after DOMContentLoaded.
       * Gate on `confirmed` — the only authoritative enable signal. */
      if (parent) {
        new MutationObserver(function () {
          if (!confirmed) {
            getExpress().forEach(function (el) {
              if (!el.classList.contains('cart-consent--express-disabled')) {
                el.classList.add('cart-consent--express-disabled');
              }
            });
          }
        }).observe(parent, { childList: true, subtree: true });
      }
    });
  }

  /* Startup */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConsentContainers);
  } else {
    initConsentContainers();
  }

  /* Re-init after AJAX cart-drawer section reload */
  new MutationObserver(function (mutations) {
    var reinit = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          n.matches('[data-cart-consent]') ||
          n.querySelector('[data-cart-consent]')
        );
      });
    });
    if (reinit) initConsentContainers();
  }).observe(document.body, { childList: true, subtree: true });
})();
